import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { getMatchScorcard } from "../../Slice/MatchScoreCardSlice";
import Loader from "../Common/Loader";
import moment from "moment";
import PlayerPositionIcon from "./PlayerPositionIcon";
import CommonService from "../../services/common.service";
import VotingModal from "./VotingModal";
import ReactHtmlParser from "react-html-parser";
import ToastComponent from "../Common/TaostComponent";
import useAutoAddQueryString from "../../Helpers/useAutoAddQueryString";
import { getClubInfo } from "../../utils/userPremiumUtils";

const MatchScorcard = () => {
  useAutoAddQueryString();
  const clubDetails = getClubInfo();
  let params = useParams(); // calling the hook
  const fixture_id = params.id;
  const dispatch = useDispatch();
  const {
    scorcard1,
    scorcard2,
    fixtureDetails,
    fixtureScorcardDetails,
    getUpdateTime,
    potmList,
    isLoading,
    isVotingActivate,
  } = useSelector((state) => state.match_scorecard);
  const [data, setData] = useState([]);
  const [sortedData, setSortedData] = useState(data);

  const [data2, setData2] = useState([]);
  const [sortedData2, setSortedData2] = useState(data);

  useEffect(() => {
    dispatch(getMatchScorcard({ fixture_id }));
    CommonService.getMatchScorcard(fixture_id).then((res) => {
      if (res.success) {
        setData(res.scorcard1);
        setSortedData(res.scorcard1);

        setData2(res.scorcard2);
        setSortedData2(res.scorcard2);
      }
    });
  }, [dispatch, fixture_id]);
  const fullNames = potmList.map((item) => item.full_name);
  const fullNamesString = fullNames.join(", ");

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    const sorted = [...data].sort((a, b) => {
      if (direction === "asc") {
        return a[key] < b[key] ? -1 : 1;
      } else {
        return a[key] > b[key] ? -1 : 1;
      }
    });
    setSortedData(sorted);
    setSortConfig({ key, direction });
  };

  const [sortConfig2, setSortConfig2] = useState({
    key: null,
    direction: "asc",
  });
  const requestSort2 = (key) => {
    let direction = "asc";
    if (sortConfig2.key === key && sortConfig2.direction === "asc") {
      direction = "desc";
    }
    const sorted = [...data2].sort((a, b) => {
      if (direction === "asc") {
        return a[key] < b[key] ? -1 : 1;
      } else {
        return a[key] > b[key] ? -1 : 1;
      }
    });
    setSortedData2(sorted);
    setSortConfig2({ key, direction });
  };

  // Specify the maximum number of characters before adding "..."
  const maxLength = 20;

  // Truncate the text if it exceeds the maxLength
  const truncatedText = (text) => {
    if (text) {
      return text.length > maxLength
        ? text.substring(0, maxLength) + "..."
        : text;
    } else {
      return "";
    }
  };
  const [showVote, setShowVote] = useState(false);
  const [playerListing, setPlayerListing] = useState([]);
  const [votingList, setVotingList] = useState([]);
  const [savedFixtureVoting, setSavedFixtureVoting] = useState([]);
  const handleVoteClose = () => setShowVote(false);
  const [topFivePlayer, setTopFivePlayer] = useState([]);
  const handleVotingModalShow = () => {
    setShowVote(true);
    CommonService.getFixturePlayerList(fixtureDetails?.id).then((res) => {
      if (res.status === 200) {
        setPlayerListing(res.playingElevPlayer);
        setVotingList(res.fixtureVotingDetails);
        setSavedFixtureVoting(res.savedFixtureVoting);
        setTopFivePlayer(res.topFivePlayer);
      }
    });
  };
  const handleVote = (playerId, votingId, voting_value) => {
    const data = {};
    data.player_id = playerId;
    data.voting_id = votingId;
    data.fixture_id = fixture_id;
    data.voting_value = voting_value;

    CommonService.saveFixtureVoting(data).then((res) => {
      if (res.success) {
        ToastComponent(res.message, "success");
        setSavedFixtureVoting(res.savedFixtureVoting);
      } else {
        ToastComponent(res.message, "error");
      }
    });
  };

  const doesCombinationExist = (fixtureId, votingId) => {
    const foundItem = savedFixtureVoting.find(
      (item) => item.fixture_id == fixtureId && item.voting_id == votingId
    );
    return foundItem?.player_id ? foundItem?.player_id : 0;
  };
  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div className="middle-section">
        <div className="profile-section matchscorecard">
          <div className="container">
            <div className="innerwhitebox">
              <div className="scorecardhead">
                <h4 className="venuetitle">
                  <a
                    className="collapsed"
                    data-bs-toggle="collapse"
                    href="#collapsevenue"
                    role="button"
                    aria-expanded="true"
                    aria-controls="collapsevenue"
                  >
                    {/* Vermont South vs East Box Hill, 2nd Match */}
                    {fixtureDetails?.team_name}
                  </a>
                </h4>
              </div>
              <ul className="careersummary collapse show" id="collapsevenue">
                <li>
                  <div className="summarybox">
                    <figure className="circle1">
                      <img src="../images/scorecard1.svg" alt="img" />
                    </figure>
                    <strong title={`${fixtureDetails?.team_name}`}>
                      {truncatedText(fixtureDetails?.team_name)}
                    </strong>
                    <span>Team</span>
                  </div>
                </li>
                <li>
                  <div className="summarybox">
                    <figure className="circle2">
                      <img src="../images/scorecard2.svg" alt="img" />
                    </figure>
                    <strong title={`${fixtureDetails?.grade_name}`}>
                      {" "}
                      {truncatedText(fixtureDetails?.grade_name)}
                    </strong>
                    <span>Comp</span>
                  </div>
                </li>
                <li>
                  <div className="summarybox">
                    <figure className="circle3">
                      <img src="../images/scorecard3.svg" alt="img" />
                    </figure>
                    <strong title={`${fixtureDetails?.opposition_club}`}>
                      {fixtureDetails?.opposition_club &&
                      fixtureDetails?.opposition_club !== ""
                        ? truncatedText(fixtureDetails?.opposition_club)
                        : "-"}
                    </strong>
                    <span>Opponent</span>
                  </div>
                </li>

                <li>
                  <div className="summarybox">
                    <figure className="circle5">
                      <img src="../images/scorecard5.svg" alt="img" />
                    </figure>
                    <strong>
                      {" "}
                      {fixtureDetails?.status === 0 ? (
                        <strong>Not Yet Started</strong>
                      ) : fixtureDetails?.status === 1 ? (
                        <strong>In-Progress</strong>
                      ) : fixtureDetails?.status === 2 ||
                        fixtureDetails?.status === 4 ? (
                        <strong>Completed</strong>
                      ) : (
                        <strong>Not Yet Started</strong>
                      )}
                    </strong>
                    <span>Status</span>
                  </div>
                </li>
                <li>
                  <div className="summarybox">
                    <figure className="circle1">
                      <img src="../images/scorecard6.svg" alt="img" />
                    </figure>
                    <strong>
                      {moment(fixtureDetails?.start_date).format("D.MM.YYYY")}
                    </strong>
                    <span>Date</span>
                  </div>
                </li>
                <li>
                  <div className="summarybox">
                    <figure className="circle2">
                      <img src="../images/scorecard7.svg" alt="img" />
                    </figure>
                    <strong>
                      {fixtureDetails?.match_type === 27
                        ? "1 - Day"
                        : "2 - Day"}
                    </strong>
                    <span>Match</span>
                  </div>
                </li>

                {fixtureDetails?.scorcard_link_name && (
                  <li>
                    <div className="summarybox">
                      <figure className="circle3">
                        <img src="../images/scorecard8.svg" alt="img" />
                      </figure>
                      <strong>
                        <a
                          href={fixtureDetails?.scorcard_link_url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {fixtureDetails?.scorcard_link_name}
                        </a>
                      </strong>
                      <span>Scorecard</span>
                    </div>
                  </li>
                )}

                <li>
                  <div className="summarybox">
                    <figure className="circle4">
                      <img src="../images/scorecard9.svg" alt="img" />
                    </figure>
                    {fixtureDetails?.vanue !== "" && (
                      <strong title={`${fixtureDetails?.vanue}`}>
                        {truncatedText(fixtureDetails?.vanue)}
                      </strong>
                    )}
                    {!fixtureDetails?.vanue && <strong>-</strong>}

                    <span>Venue</span>
                  </div>
                </li>
              </ul>
            </div>
            <div className="innerwhitebox innerwhite-section">
              <ul className="nav tradetab nav-tabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="Overall-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#Overall"
                    type="button"
                    role="tab"
                    aria-controls="Overall"
                    aria-selected="true"
                  >
                    1st Innings
                  </button>
                </li>
                {fixtureDetails?.match_type === 28 && (
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="Gameweek-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#Gameweek"
                      type="button"
                      role="tab"
                      aria-controls="Gameweek"
                      aria-selected="true"
                    >
                      2nd Innings
                    </button>
                  </li>
                )}
              </ul>
              <div
                className="tab-content scorecardtabcontent nopadding"
                id="myTabContent"
              >
                <div
                  className="tab-pane fade show active"
                  id="Overall"
                  role="tabpanel"
                  aria-labelledby="Overall-tab"
                >
                  <div className="recentperformance">
                    {isVotingActivate === 1 && fixtureDetails.status == 2 && (
                      <div className="searchfilter">
                        <Link
                          href=""
                          className="vote-btn"
                          onClick={(event) => {
                            event.preventDefault();
                            handleVotingModalShow();
                          }}
                        >
                          <img src="../images/vote-icon.svg" alt="img" />
                          Vote
                        </Link>
                      </div>
                    )}
                    <div id="table-scroll4" className="table-scroll">
                      <div className="table-wrap">
                        <table className="main-table4 table innertable">
                          <thead>
                            <tr>
                              <th
                                onClick={() => requestSort("player_name")}
                                style={{ cursor: "pointer" }}
                              >
                                Player Name{" "}
                                {sortConfig.key === "player_name" &&
                                  (sortConfig.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort("rs")}
                                style={{ cursor: "pointer" }}
                              >
                                R{" "}
                                {sortConfig.key === "rs" &&
                                  (sortConfig.direction === "asc" ? "↑" : "↓")}
                              </th>
                              {clubDetails?.game_type === 3 && (
                                <>
                                  <th
                                    onClick={() => requestSort("ones")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"1"}
                                    {sortConfig.key === "ones" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort("twos")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"2"}
                                    {sortConfig.key === "twos" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort("threes")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"3"}
                                    {sortConfig.key === "threes" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort("fours")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"4"}
                                    {sortConfig.key === "fours" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort("fives")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"5"}
                                    {sortConfig.key === "fives" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort("sixes")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"6"}
                                    {sortConfig.key === "sixes" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort("sevens")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"7"}
                                    {sortConfig.key === "sevens" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort("eights")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"8"}
                                    {sortConfig.key === "eights" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort("nines")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"9"}
                                    {sortConfig.key === "nines" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort("outs")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"Outs"}
                                    {sortConfig.key === "outs" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                </>
                              )}

                              {clubDetails?.game_type !== 3 && (
                                <>
                                  <th
                                    onClick={() => requestSort("fours")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"4"}
                                    {sortConfig.key === "fours" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort("sixes")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"6"}
                                    {sortConfig.key === "sixes" &&
                                      (sortConfig.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                </>
                              )}

                              <th
                                onClick={() => requestSort("overs")}
                                style={{ cursor: "pointer" }}
                              >
                                {"OVS"}
                                {sortConfig.key === "overs" &&
                                  (sortConfig.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort("mdns")}
                                style={{ cursor: "pointer" }}
                              >
                                {"MDS"}
                                {sortConfig.key === "mdns" &&
                                  (sortConfig.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort("run")}
                                style={{ cursor: "pointer" }}
                              >
                                {"RG"}
                                {sortConfig.key === "run" &&
                                  (sortConfig.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort("wks")}
                                style={{ cursor: "pointer" }}
                              >
                                {"WK"}
                                {sortConfig.key === "wks" &&
                                  (sortConfig.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort("cs")}
                                style={{ cursor: "pointer" }}
                              >
                                {"CS"}
                                {sortConfig.key === "cs" &&
                                  (sortConfig.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort("cwks")}
                                style={{ cursor: "pointer" }}
                              >
                                {"CW"}
                                {sortConfig.key === "cwks" &&
                                  (sortConfig.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort("sts")}
                                style={{ cursor: "pointer" }}
                              >
                                {"ST"}
                                {sortConfig.key === "sts" &&
                                  (sortConfig.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort("rods")}
                                style={{ cursor: "pointer" }}
                              >
                                {"ROD"}
                                {sortConfig.key === "rods" &&
                                  (sortConfig.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort("roas")}
                                style={{ cursor: "pointer" }}
                              >
                                {"ROA"}
                                {sortConfig.key === "roas" &&
                                  (sortConfig.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort("dks")}
                                style={{ cursor: "pointer" }}
                              >
                                {"DK"}
                                {sortConfig.key === "dks" &&
                                  (sortConfig.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort("hattrick")}
                                style={{ cursor: "pointer" }}
                              >
                                {"HT"}
                                {sortConfig.key === "hattrick" &&
                                  (sortConfig.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort("fantasy_points")}
                                style={{ cursor: "pointer" }}
                              >
                                {"FPS"}
                                {sortConfig.key === "fantasy_points" &&
                                  (sortConfig.direction === "asc" ? "↑" : "↓")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {sortedData.length > 0 &&
                              sortedData.map((item, key) => (
                                <tr key={key}>
                                  <td>
                                    <Link
                                      to={`/player-profile/${item.player_id}`}
                                    >
                                      {item.player_name}
                                    </Link>
                                  </td>
                                  <td>{item.rs ? item.rs : 0}</td>

                                  {clubDetails?.game_type === 3 && (
                                    <>
                                      <td>{item.ones ? item.ones : 0}</td>
                                      <td>{item.twos ? item.twos : 0}</td>
                                      <td>{item.threes ? item.threes : 0}</td>
                                      <td>{item.fours ? item.fours : 0}</td>
                                      <td>{item.fives ? item.fives : 0}</td>
                                      <td>{item.sixes ? item.sixes : 0}</td>
                                      <td>{item.sevens ? item.sevens : 0}</td>
                                      <td>{item.eights ? item.eights : 0}</td>
                                      <td>{item.nines ? item.ones : 0}</td>
                                      <td>{item.outs ? item.outs : 0}</td>
                                    </>
                                  )}
                                  {clubDetails?.game_type !== 3 && (
                                    <>
                                      <td>{item.fours ? item.fours : 0}</td>
                                      <td>{item.sixes ? item.sixes : 0}</td>
                                    </>
                                  )}

                                  <td>{item.overs ? item.overs : 0}</td>
                                  <td>{item.mdns ? item.mdns : 0}</td>
                                  <td>{item.run ? item.run : 0}</td>
                                  <td>{item.wks ? item.wks : 0}</td>
                                  <td>{item.cs ? item.cs : 0}</td>
                                  <td>{item.cwks ? item.cwks : 0}</td>
                                  <td>{item.sts ? item.sts : 0}</td>
                                  <td>{item.rods ? item.rods : 0}</td>
                                  <td>{item.roas ? item.roas : 0}</td>
                                  <td>{item.dks ? "Yes" : "No"}</td>
                                  <td>{item.hattrick ? "Yes" : "No"}</td>
                                  <td>{item.fantasy_points}</td>
                                </tr>
                              ))}
                            {scorcard1.length === 0 && (
                              <tr>
                                <td colSpan={16}>No record yet available.</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <p className="scoresupdated">
                        *Scores updated on{" "}
                        {moment(getUpdateTime).format("D.MM.YYYY")} at{" "}
                        {moment(getUpdateTime).format("h:mm A")} |{" "}
                        <a
                          href={fixtureDetails?.scorcard_link_url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {fixtureDetails?.scorcard_link_name}
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="Gameweek"
                  role="tabpanel"
                  aria-labelledby="Gameweek-tab"
                >
                  <div className="recentperformance">
                    {/* <div className="searchfilter">
                      <Link
                        className="vote-btn"
                        data-bs-toggle="modal"
                        data-bs-target="#votemodal"
                      >
                        Vote
                      </Link>
                      <div className="custom-searchbox">
                        <Link className="searchicon">
                          <img src="images/search-icon.png" alt="img" />
                        </Link>
                        <div className="searchbox">
                          <input type="text" className="form-control" />
                          <Link className="closeicon">
                            <img src="images/close-icon-blue.png" alt="img" />
                          </Link>
                        </div>
                      </div>
                      <div className="dropdown">
                        <Link
                          className="dropdown-toggle"
                          role="button"
                          id="filter2"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <img src="images/filter.png" alt="img" />
                        </Link>

                        <ul className="dropdown-menu" aria-labelledby="filter2">
                          <li>
                            <Link className="dropdown-item">Gameweek 2</Link>
                          </li>
                        </ul>
                      </div>
                    </div> */}
                    <div id="table-scroll2" className="table-scroll">
                      <div className="table-wrap">
                        <table className="main-table2 table innertable">
                          <thead>
                            <tr>
                              <th
                                onClick={() => requestSort2("player_name")}
                                style={{ cursor: "pointer" }}
                              >
                                Player Name{" "}
                                {sortConfig2.key === "player_name" &&
                                  (sortConfig2.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort2("rs")}
                                style={{ cursor: "pointer" }}
                              >
                                R{" "}
                                {sortConfig2.key === "rs" &&
                                  (sortConfig2.direction === "asc" ? "↑" : "↓")}
                              </th>
                              {clubDetails?.game_type === 3 && (
                                <>
                                  <th
                                    onClick={() => requestSort2("ones")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"1"}
                                    {sortConfig2.key === "ones" &&
                                      (sortConfig2.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort2("twos")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"2"}
                                    {sortConfig2.key === "twos" &&
                                      (sortConfig2.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort2("threes")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"3"}
                                    {sortConfig2.key === "threes" &&
                                      (sortConfig2.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort2("fours")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"4"}
                                    {sortConfig2.key === "fours" &&
                                      (sortConfig2.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort2("fives")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"5"}
                                    {sortConfig2.key === "fives" &&
                                      (sortConfig2.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort2("sixes")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"6"}
                                    {sortConfig2.key === "sixes" &&
                                      (sortConfig2.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort2("sevens")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"7"}
                                    {sortConfig2.key === "sevens" &&
                                      (sortConfig2.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort2("eights")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"8"}
                                    {sortConfig2.key === "eights" &&
                                      (sortConfig2.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort2("nines")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"9"}
                                    {sortConfig2.key === "nines" &&
                                      (sortConfig2.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort2("outs")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"Outs"}
                                    {sortConfig2.key === "outs" &&
                                      (sortConfig2.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                </>
                              )}
                              {clubDetails?.game_type !== 3 && (
                                <>
                                  <th
                                    onClick={() => requestSort2("fours")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"4"}
                                    {sortConfig2.key === "fours" &&
                                      (sortConfig2.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                  <th
                                    onClick={() => requestSort2("sixes")}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {"6"}
                                    {sortConfig2.key === "sixes" &&
                                      (sortConfig2.direction === "asc"
                                        ? "↑"
                                        : "↓")}
                                  </th>
                                </>
                              )}
                              <th
                                onClick={() => requestSort2("overs")}
                                style={{ cursor: "pointer" }}
                              >
                                {"OVS"}
                                {sortConfig2.key === "overs" &&
                                  (sortConfig2.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort2("mdns")}
                                style={{ cursor: "pointer" }}
                              >
                                {"MDS"}
                                {sortConfig2.key === "mdns" &&
                                  (sortConfig2.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort2("run")}
                                style={{ cursor: "pointer" }}
                              >
                                {"RG"}
                                {sortConfig2.key === "run" &&
                                  (sortConfig2.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort2("wks")}
                                style={{ cursor: "pointer" }}
                              >
                                {"WK"}
                                {sortConfig2.key === "wks" &&
                                  (sortConfig2.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort2("cs")}
                                style={{ cursor: "pointer" }}
                              >
                                {"CS"}
                                {sortConfig2.key === "cs" &&
                                  (sortConfig2.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort2("cwks")}
                                style={{ cursor: "pointer" }}
                              >
                                {"CW"}
                                {sortConfig2.key === "cwks" &&
                                  (sortConfig2.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort2("sts")}
                                style={{ cursor: "pointer" }}
                              >
                                {"ST"}
                                {sortConfig2.key === "sts" &&
                                  (sortConfig2.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort2("rods")}
                                style={{ cursor: "pointer" }}
                              >
                                {"ROD"}
                                {sortConfig2.key === "rods" &&
                                  (sortConfig2.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort2("roas")}
                                style={{ cursor: "pointer" }}
                              >
                                {"ROA"}
                                {sortConfig2.key === "roas" &&
                                  (sortConfig2.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort2("dks")}
                                style={{ cursor: "pointer" }}
                              >
                                {"DK"}
                                {sortConfig2.key === "dks" &&
                                  (sortConfig2.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort2("hattrick")}
                                style={{ cursor: "pointer" }}
                              >
                                {"HT"}
                                {sortConfig2.key === "hattrick" &&
                                  (sortConfig2.direction === "asc" ? "↑" : "↓")}
                              </th>
                              <th
                                onClick={() => requestSort2("fantasy_points")}
                                style={{ cursor: "pointer" }}
                              >
                                {"FPS"}
                                {sortConfig2.key === "fantasy_points" &&
                                  (sortConfig2.direction === "asc" ? "↑" : "↓")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {sortedData2.length > 0 &&
                              sortedData2.map((item, key) => (
                                <tr key={key}>
                                  <td>
                                    <Link
                                      to={`/player-profile/${item.player_id}`}
                                    >
                                      {item.player_name}
                                    </Link>
                                  </td>
                                  <td>{item.rs ? item.rs : 0}</td>
                                  {clubDetails?.game_type === 3 && (
                                    <>
                                      <td>{item.ones ? item.ones : 0}</td>
                                      <td>{item.twos ? item.twos : 0}</td>
                                      <td>{item.threes ? item.threes : 0}</td>
                                      <td>{item.fours ? item.fours : 0}</td>
                                      <td>{item.fives ? item.fives : 0}</td>
                                      <td>{item.sixes ? item.sixes : 0}</td>
                                      <td>{item.sevens ? item.sevens : 0}</td>
                                      <td>{item.eights ? item.eights : 0}</td>
                                      <td>{item.nines ? item.ones : 0}</td>
                                      <td>{item.outs ? item.outs : 0}</td>
                                    </>
                                  )}
                                  {clubDetails?.game_type !== 3 && (
                                    <>
                                      <td>{item.fours ? item.fours : 0}</td>
                                      <td>{item.sixes ? item.sixes : 0}</td>
                                    </>
                                  )}
                                  <td>{item.overs ? item.overs : 0}</td>
                                  <td>{item.mdns ? item.mdns : 0}</td>
                                  <td>{item.run ? item.run : 0}</td>
                                  <td>{item.wks ? item.wks : 0}</td>
                                  <td>{item.cs ? item.cs : 0}</td>
                                  <td>{item.cwks ? item.cwks : 0}</td>
                                  <td>{item.sts ? item.sts : 0}</td>
                                  <td>{item.rods ? item.rods : 0}</td>
                                  <td>{item.roas ? item.roas : 0}</td>
                                  <td>{item.dks ? "Yes" : "No"}</td>
                                  <td>{item.hattrick ? "Yes" : "No"}</td>
                                  <td>{item.fantasy_points}</td>
                                </tr>
                              ))}
                            {scorcard2.length === 0 && (
                              <tr>
                                <td colSpan={16}>No record yet available.</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <p className="scoresupdated">
                        *Scores updated on{" "}
                        {moment(getUpdateTime).format("D.MM.YYYY")} at{" "}
                        {moment(getUpdateTime).format("h:mm A")} |{" "}
                        <a
                          href={fixtureDetails?.scorcard_link_url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {fixtureDetails?.scorcard_link_name}
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="match-statistics">
                <ul>
                  <li>
                    <h5>Match Result</h5>
                    <span>
                      {fixtureDetails?.potm_match_status == 1 ? "Won" : "Other"}
                    </span>
                  </li>
                  {fullNamesString && (
                    <li>
                      <h5>Player of the Match</h5>
                      <span>{fullNamesString}</span>
                    </li>
                  )}

                  <li>
                    <h5>Fall Of Wickets</h5>

                    {fixtureDetails?.fall_of_wickets
                      ? ReactHtmlParser(fixtureDetails?.fall_of_wickets)
                      : "-"}
                  </li>
                </ul>
              </div>
              <div className="legend-btn">
                <Link
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#gamekey"
                >
                  Legend Keys
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="gamekey"
        tabIndex="-1"
        aria-labelledby="gamekey"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Legend Keys</h5>
            </div>
            <div className="modal-body">
              <div className="column legend">
                <div className="left-column">
                  <ul className="legend">
                    <li>
                      <strong>PTS:</strong>
                      <span>Points</span>
                    </li>
                    <li>
                      <strong>R:</strong>
                      <span>Runs</span>
                    </li>
                    <li>
                      <strong>4:</strong>
                      <span>Fours</span>
                    </li>
                    <li>
                      <strong>6:</strong>
                      <span>Sixes</span>
                    </li>
                    <li>
                      <strong>MDS:</strong>
                      <span>Maidens</span>
                    </li>
                  </ul>
                </div>
                <div className="right-column">
                  <ul className="legend">
                    <li>
                      <strong>WK:</strong>
                      <span>Wickets</span>
                    </li>
                    <li>
                      <strong>CS:</strong>
                      <span>Catches</span>
                    </li>
                    <li>
                      <strong>HT:</strong>
                      <span>Hat-Trick</span>
                    </li>
                    <li>
                      <strong>VC:</strong>
                      <span>Value Change</span>
                    </li>
                    <li>
                      <strong>FV:</strong>
                      <span>Fantasy Value</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="poweredby">
                Powered By
                <img src="/images/logo.png" alt="img" />
              </div>
              <div className="">
                <a href="0" className="border-btn" data-bs-dismiss="modal">
                  Close
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <VotingModal
        show={showVote}
        setShow={setShowVote}
        handleClose={handleVoteClose}
        playerListing={playerListing}
        votingList={votingList}
        handleVote={handleVote}
        savedFixtureVoting={savedFixtureVoting}
        fixture_id={fixture_id}
        doesCombinationExist={doesCombinationExist}
        topFivePlayer={topFivePlayer}
      />
    </>
  );
};

export default MatchScorcard;
